var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCn = function SvgCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.567 7.301 1.036 3.188h3.352l-2.71 1.973 1.036 3.188-2.714-1.969-2.714 1.969 1.04-3.188L2.18 10.49H5.53L6.567 7.3ZM14.226 18.585l-.792-.975-1.172.454.68-1.054-.793-.98 1.215.323.684-1.054.066 1.256 1.218.323-1.176.45.07 1.257ZM15.802 15.725l.375-1.2-1.027-.726 1.257-.019.37-1.2.408 1.19 1.256-.013-1.008.75.403 1.19-1.026-.726-1.008.754ZM17.926 8.807l-.553 1.13.9.876-1.243-.178-.553 1.125-.215-1.238-1.247-.178 1.115-.586-.215-1.242.9.877 1.11-.586ZM14.26 5.385l-.095 1.252 1.168.473-1.224.3-.089 1.256-.66-1.068-1.224.3.81-.961-.665-1.064 1.167.473.811-.961Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCn;